/*
 * King Living Badge — cart count pill (Figma Cart icon / Num).
 */

export default {
  baseStyle: {
    textTransform: 'none',
  },
  variants: {
    notification: {
      alignItems: 'center',
      backgroundColor: '#1B1A18',
      border: 'none',
      borderRadius: 'full',
      bottom: '-4px',
      boxSizing: 'border-box',
      color: 'white',
      display: 'inline-flex',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: '11px',
      fontWeight: 500,
      height: '14px',
      justifyContent: 'center',
      lineHeight: 1.2,
      minWidth: '14px',
      paddingX: '2px',
      paddingY: 0,
      position: 'absolute',
      right: '-4px',
      textTransform: 'none',
      top: 'auto',
      left: 'auto',
    },
  },
};
